import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  ElementRef,
  NgZone,
} from "@angular/core";
import { APIService } from "src/app/api/api.service";
import { NotifierService } from "src/app/_services/notifier.service";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { ServiceService } from "./charges/chargesbyservice/chargeser.service";
import { AllChargesByServiceComponent } from "./allaccountcharges/chargesbyser_all/chargesbyservice.component";
import * as moment from "moment";

declare let $: any;
declare let html2pdf: any;

@Component({
  selector: "app-main-billing",
  templateUrl: "./billingmain.component.html",
  styleUrls: ["./billingmain.component.css"],
})
export class BillingMainComponent implements OnInit, OnDestroy {
  activeTab: string = "";
  summary: any;
  highestspend: any;
  monthYear: string = "";
  accountId: string = "";
  regionId: string = "";
  account: any;
  mode: string = "";

  @ViewChild(AllChargesByServiceComponent)
  allChargesComp?: AllChargesByServiceComponent;

  private routerSub?: Subscription;
  private currentMessage?: Subscription;
  download: any;
  downloadAll: any;

  constructor(
    private apiServer: APIService,
    public notifier: NotifierService,
    private router: Router,
    private route: ActivatedRoute,
    private service: ServiceService,
    private zone: NgZone
  ) {}

  ngOnInit(): void {
    this.mode = this.route.snapshot.data["mode"] || "monthly";
    this.initializeComponent();

    // Re-run logic when navigating between /main and /all-accounts
    this.routerSub = this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe(() => {
        const newMode = this.route.snapshot.data["mode"];
        if (newMode !== this.mode) {
          this.mode = newMode;
          this.initializeComponent();
        }
      });
  }

  private initializeComponent(): void {

    this.accountId = localStorage.getItem("accountId") || "";
    this.regionId = localStorage.getItem("regionId") || "";

    this.initDatePicker();

    this.currentMessage?.unsubscribe();
    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d;
      try {
        d = JSON.parse(msg);
      } catch {
        return;
      }
      if (!d.value) return;

      if (d.key === "accountId") {
        this.accountId = d.value;
        this.initDatePicker();
        this.mode === "monthly"
          ? (this.loadSummary(), this.highestCost())
          : this.loadAllAccountsBill();
      } else if (d.key === "regionId" && this.mode === "monthly") {
        this.regionId = d.value;
        this.initDatePicker();
        this.loadSummary();
        this.highestCost();
      }
    });

    // 👇 Load data + set active tab based on mode
    if (this.mode === "monthly") {
      this.activeTab = "service";
      this.loadSummary();
      this.highestCost();
    } else if (this.mode === "allAccounts") {
      this.activeTab = "account";
      this.loadAllAccountsBill();
    }
  }

  private initDatePicker(): void {
    $(".datetimepicker")
      .datepicker({
        autoclose: true,
        minViewMode: 1,
        format: "mm-yyyy",
        orientation: "bottom auto",
        endDate: new Date(),
      })
      .off("changeDate")
      .on("changeDate", (ev: any) => {
        const picked = moment(ev.dates[0]).format("MM-YYYY");
        $(".datetimepicker").val(picked);

        this.zone.run(() => {
          if (this.mode === "monthly") {
            this.loadSummary();
            this.highestCost();
          } else if (this.mode === "allAccounts") {
            this.loadAllAccountsBill();
          }
        });
      });

    $(".datetimepicker").val(
      this.monthYear || moment().startOf("month").format("MM-YYYY")
    );
  }

  // ======================================================
  // 🧩 ALL ACCOUNTS LOGIC
  // ======================================================
  async loadAllAccountsBill() {
    this.monthYear = moment().startOf("month").format("MM-YYYY");
    let dRange = $(".datetimepicker").val();
    if (dRange) {
      const parts = dRange.toString().split("-");
      this.monthYear = `${parts[0]}-${parts[1]}`;
    }

    const stored = localStorage.getItem("accountIdData");
    let ids: string[] = [];

    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        const list = parsed.list || [];
        ids = list.map((item: any) => String(item.accountId)).filter(Boolean);
      } catch (err) {
        console.error("❌ [loadAllAccountsBill] Error parsing localStorage:", err);
      }
    }

    if (!ids.length && this.accountId) ids = [this.accountId];
    if (!ids.length) {
      return;
    }

    const allAccountIds = ids.join(",");
    await this.loadSummary(allAccountIds);
    await this.highestCost(allAccountIds);
  }

  async loadSummary(accountIdsFromAll?: string) {
    this.notifier.loading(true);
    this.monthYear = moment().startOf("month").format("MM-YYYY");

    let dRange = $(".datetimepicker").val();
    if (dRange) {
      const parts = dRange.toString().split("-");
      this.monthYear = `${parts[0]}-${parts[1]}`;
    }

    const [month, year] = this.monthYear.split("-");
    const params: any = {
      account_ids: accountIdsFromAll || this.accountId,
      year,
      month,
    };

    try {
      const { result } = await this.service.loadSummary(params);
      this.summary = (result as any)?.response?.all_account_cost_summary;
      this.account =
      this.mode === 'monthly'
      ? (result as any)?.response?.accounts?.[0]?.account_id ?? this.accountId
      : (result as any)?.response?.master_account_id;
      const query = this.route.snapshot.queryParams;
      this.activeTab = "open" in query ? "account" : "service";
    } catch (error) {
      console.error("❌ [loadSummary] API Error:", error);
    } finally {
      this.notifier.loading(false);
    }
  }

  async onDownloadReport() {
    let dRange = $(".datetimepicker").val();
    const query = this.route.snapshot.queryParams;
    const [month, year] = dRange
      ? dRange.toString().split("-")
      : moment().startOf("month").format("MM-YYYY").split("-");
  const params = {
  month,
  year,
  account_ids: this.accountId,
  type: "monthly",
  export: "csv",
  ...(query.breakup && { breakup: query.breakup })
};

  try {
    await this.service.downloadAllToCSV(params);
  } catch (err) {
    console.error('Download failed', err);
  }
}
async exportPDF(event?: any) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  this.notifier.loading(true);
  this.download = "pdf";

  let lids: string[] = [];

  if (this.downloadAll) {
    const raw = localStorage.getItem("accountIdData");
    const accounts = JSON.parse(raw || "{}");
    lids = (accounts.list || []).map((a: any) => a.accountId);
  } else {
    lids = [this.accountId];
  }

  lids = [...new Set(lids)];

  if (!lids.length) {
    this.notifier.loading(false);
    return;
  }

  const routeParams = this.route.snapshot.queryParams;
  const [month, year] = this.monthYear.split("-");

  const monthName = new Date(+year, +month - 1).toLocaleString("en-US", {
    month: "long"
  });

  for (const accountId of lids) {
    try {
      const { result } = await this.service.exportPDF({
        account_ids: accountId,
        month,
        year,
        ...routeParams,
        export: "pdf",
        type: "monthly"
      });

      const responseArray = (result as any)?.response ?? [];

      const headers = [
        "Service",
        "Region",
        "Level",
        "Description",
        "Usage",
        "Unit",
        "Base Cost",
        "Final Cost"
      ];

      const rows = responseArray.length
        ? responseArray.map((item: any) => `
          <tr style="page-break-inside:avoid;">
            <td style="border:1px solid yellow; padding:4px">${item.Service || "-"}</td>
            <td style="border:1px solid yellow; padding:4px">${item.REGION || "-"}</td>
            <td style="border:1px solid yellow; padding:4px">${item.level || "-"}</td>
            <td style="border:1px solid yellow; padding:4px">${item.name || "-"}</td>
            <td style="border:1px solid yellow; padding:4px; text-align:right">${item.usage ?? "-"}</td>
            <td style="border:1px solid yellow; padding:4px">${item.unit || "-"}</td>
            <td style="border:1px solid yellow; padding:4px; text-align:right">
              $${Number(item.base_cost || 0).toFixed(2)}
            </td>
            <td style="border:1px solid yellow; padding:4px; text-align:right">
              $${Number(item.final_cost || 0).toFixed(2)}
            </td>
          </tr>
        `).join("")
        : `
          <tr>
            <td colspan="${headers.length}" style="border:1px solid yellow; padding:6px; text-align:center">
              No AWS usage found
            </td>
          </tr>
        `;

      const totalRow = `
        <tr style="font-weight:bold; background:#fff176;">
          <td colspan="${headers.length - 2}" style="border:1px solid yellow; padding:4px; text-align:right">
            Total:
          </td>
          <td style="border:1px solid yellow; padding:4px; text-align:right">
            $${Number(this.summary.total_base_cost || 0).toFixed(2)}
          </td>
          <td style="border:1px solid yellow; padding:4px; text-align:right">
            $${Number(this.summary.total_final_cost || 0).toFixed(2)}
          </td>
        </tr>
      `;

      const element = document.createElement("div");
      element.innerHTML = `
        <div style="padding:0 25px; font-family:Arial; color:#000">

          <!-- HEADER -->
          <div style="display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:20px">

            <div style="flex:1">
              <img src="../assets/img/minfy_logo.png" style="max-width:220px" />
            </div>

            <div style="flex:1; text-align:right">
              <p style="font-weight:bold; font-size:16px; margin:0">
                AWS Usage Report
              </p>
              <p style="font-size:12px; margin:4px 0">
                Customer: <strong>${accountId}</strong>
              </p>
              <p style="font-size:12px; margin:4px 0">
                Billing Period: <strong>${monthName} - ${year}</strong>
              </p>
              <p style="font-size:12px; margin:4px 0">
                Contact: billing-support@minfytech.com
              </p>
            </div>

          </div>

          <!-- AWS + Marketplace -->
          <div style="display:flex; justify-content:space-between; margin-top:10px">

            <div style="flex:1">
              <p style="font-size:12px; margin:0; font-weight:bold">
                Amazon Web Services India Private Limited
              </p>
              <p style="font-size:12px; margin-top:4px">
                Total in USD:
                <strong>$${Number(this.summary.total_aws_cost || 0).toFixed(2)}</strong>
              </p>
            </div>

            <div style="flex:1; text-align:right">
              <p style="font-size:12px; margin:0; font-weight:bold">
                Amazon Web Services, Inc. – Marketplace
              </p>
              <p style="font-size:12px; margin-top:4px">
                Total in USD:
                <strong>$${Number(this.summary.total_market_place_cost || 0).toFixed(2)}</strong>
              </p>
            </div>

          </div>

          <p style="font-size:13px; font-weight:bold; margin-top:12px">
            Estimated Grand Total: USD ${Number(this.summary.total_final_cost || 0).toFixed(2)}
          </p>

          <table style="width:100%; margin-top:20px; border:2px solid yellow; border-collapse:collapse; font-size:12px">
            <thead>
              <tr style="background:#c8e1f5">
                ${headers.map(h => `
                  <th style="border:1px solid yellow; padding:6px">${h}</th>
                `).join("")}
              </tr>
            </thead>
            <tbody>
              ${rows}
              ${totalRow}
            </tbody>
          </table>

        </div>
      `;

      await html2pdf().set({
        margin: 5,
        filename: `${accountId}_${month}-${year}.pdf`,
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 4 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }
      }).from(element).save();

    } catch (err) {
      console.error("PDF error:", err);
    }
  }

  this.download = null;
  this.notifier.loading(false);
}

 async highestCost(accountIdsFromAll?: string) {
    this.notifier.loading(true);
    let dRange = $(".datetimepicker").val();
    const [month, year] = dRange
      ? dRange.toString().split("-")
      : moment().startOf("month").format("MM-YYYY").split("-");

    const params: any = {
      account_ids: accountIdsFromAll || this.accountId,
      year,
      month,
    };
          if(this.mode == 'monthly'){
        params.type = "single_account"
      }
      else{
        params.type ="all_accounts"
      }

    try {
      const { result } = await this.service.loadhighestCost(params);
      this.highestspend = (result as any).response;
    } catch (error) {
      console.error("❌ [highestCost] API Error:", error);
    } finally {
      this.notifier.loading(false);
    }
  }

  switchTab(tabName: string): void {
    this.notifier.loading(true);
    this.activeTab = tabName;

    const query = this.route.snapshot.queryParams;
    if ("open" in query || !("_t" in query)) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {},
        queryParamsHandling: "",
      });
    }

    // Stop loader after brief UI update
    setTimeout(() => this.notifier.loading(false), 400);
  }

  // ✳️ Event: Called when AllChargesByServiceComponent finishes ngOnInit
  onAllChargesReady(): void {
    this.allChargesComp?.load();
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
    this.currentMessage?.unsubscribe();
  }
}
